module.exports = __webpack_public_path__ + "img/menu5.6d715e08.png";